import {JSX, useState} from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button, LinearProgress
} from '@mui/material';
import {
    Close as CloseIcon,
    Add as AddIcon
} from '@mui/icons-material';
import {
    BooleanInput,
    Create,
    required,
    SelectInput,
    SimpleForm,
    TextInput,
    useCreate,
    useNotify,
    useRefresh
} from "react-admin";
import { ChatFieldBridge } from "../../../chat-bot/components/ChatFieldBridge";

export const CreateNewCustomerForAccountModal: () => JSX.Element = (): JSX.Element => {
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [create] = useCreate();
    const notify: any = useNotify();
    const refresh: any = useRefresh();

    function handleClose(): void {
        setOpenModal(false);
    }

    function handleOpen(): void {
        setOpenModal(true);
    }

    function handleSubmit(values: any): void {
        // No `adminCreatedCustomerSendWelcomeEmails` is sent any more, and nothing reads one.
        // This modal always set it to true, and on the API side that flag gated the customer's
        // password, roles, terms flag and created date as well as the email, so a caller that
        // left it out got a 500 rather than a customer. The API prepares and emails every
        // admin-created customer now. HQAPI-39, 2026-09-11.
        create(
            'customers',
            {
                data: values
            },
            {
                onSuccess: async (data: any): Promise<void> => {
                    refresh();
                    notify(`New customer created!`, { type: "success" });
                    handleClose();
                },
                onError: (error: any): void => {
                    let errorMessage: string;
                    if (typeof error === 'string') {
                        errorMessage = error;
                    } else {
                        errorMessage = error.message;
                    }
                    notify(`Failed to create error: ${errorMessage}`, { type: 'error' });
                },
            }
        )
    }

    return (
        <>
            <Button variant='contained' onClick={ handleOpen } >
                { "Add New Customer " }
                <AddIcon />
            </Button>
            <Dialog
                maxWidth="lg"
                fullWidth
                open={ openModal }
                onClose={ handleClose }>
                <DialogTitle>
                    <div style={ { width: '100%', display: 'flex', justifyContent: 'space-between' } }>
                        <span>{ "Create new Customer" }</span>
                        <button type="button"
                                onClick={ handleClose }
                                style={ { cursor: 'pointer' } }>
                            <CloseIcon />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <Create resource="customers" title=" ">
                        <SimpleForm onSubmit={ handleSubmit }>
                            { /* HQAPI-100: this modal sent one `name` and no name parts, and
                                 `first_name` and `last_name` are NOT NULL, so every create it
                                 made was refused by the database and the admin saw
                                 "Failed to create error". It asks for the two parts now, the
                                 same pair the assistant's conversion card asks for. `name` is
                                 built from them by CustomerCreateBeforeSubscriber rather than
                                 concatenated here, so all three create paths name a customer
                                 the same way. */ }
                            <TextInput source="firstName" label="First name" validate={ [required()] } />
                            <TextInput source="lastName" label="Last name" validate={ [required()] } />
                            <TextInput source="email" validate={ [required()] } />
                            { /* Offers this modal to the assistant. Renders nothing, writes nothing by
                                 itself. HQ-12: the registry is a stack now, so this no longer displaces
                                 the page form underneath. */ }
                            <ChatFieldBridge />
                        </SimpleForm>
                    </Create>
                </DialogContent>
            </Dialog>
        </>
    );
}